import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import viewImage from "../../../assets/images/icons/view.svg";
import TablePagination from "../../../commons/Pagination/TablePagination";
const PendingRestaurant = () => {
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  return (
    <>
      <div className="table-responsive px-0">
        <table className="table table-striped trim">
          <thead>
            <tr>
              <th width="80">Restaurant ID</th>
              <th width="150">Name</th>
              <th>Email id</th>
              <th>Mobile Number</th>
              <th>Status</th>
              <th className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>                      
              <tr>
                  <td>#2313343</td>
                  <td>Chuckles Jack</td>
                  <td>Xyz@Gmail.Com</td>
                  <td>+44 12345 54321</td>
                  <td>Pending</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/menu-and-restaurant/pending-restaurant/view-restaurant-registration' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>#2313343</td>
                  <td>Chuckles Jack</td>
                  <td>Xyz@Gmail.Com</td>
                  <td>+44 12345 54321</td>
                  <td>Pending</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/menu-and-restaurant/pending-restaurant/view-restaurant-registration' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>#2313343</td>
                  <td>Chuckles Jack</td>
                  <td>Xyz@Gmail.Com</td>
                  <td>+44 12345 54321</td>
                  <td>Pending</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/menu-and-restaurant/pending-restaurant/view-restaurant-registration' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>#2313343</td>
                  <td>Chuckles Jack</td>
                  <td>Xyz@Gmail.Com</td>
                  <td>+44 12345 54321</td>
                  <td>Pending</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/menu-and-restaurant/pending-restaurant/view-restaurant-registration' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              <tr>
                  <td>#2313343</td>
                  <td>Chuckles Jack</td>
                  <td>Xyz@Gmail.Com</td>
                  <td>+44 12345 54321</td>
                  <td>Pending</td>
                  <td>
                      <div className="d-flex align-items-center justify-content-center">
                          <Link to='/menu-and-restaurant/pending-restaurant/view-restaurant-registration' className="mx-2">
                              <img src={viewImage} alt="View" />
                          </Link>
                      </div>
                  </td>
              </tr>
              {/* <tr>
                <td colSpan="6" className="text-center py-4">
                  No Data Found
                </td>
              </tr> */}
          </tbody>
        </table>
      </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

    </>
  );
};

export default PendingRestaurant;